import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MenuItem from './menuItem'
import MenuTree from './menuTree'
import { withRouter } from 'react-router-dom';

import { carregarUsuario } from '../../auth/authActions';

class Menu extends Component {

	state = {
		acessoAberto: null,
		cadastroAberto: null
	}

	constructor(props) {
		super(props);

		let idInterval = setInterval(() => {
			if (this.props.usuario) {
				this.props.carregarUsuario();
				clearInterval(idInterval);
			}
		}, 2000);
	}

	render() {

		const usuarioCarregado = this.props.usuarioCarregado;

		let selecionado = '';
		if (this.props.location && this.props.location.pathname) {
			selecionado = this.props.location.pathname;
		}

		if (selecionado != '/' 
			&& this.state.acessoAberto == null
			&& this.state.cadastroAberto == null
		) {
			if (selecionado == '/usuario') {
				this.setState({
					...this.state,
					acessoAberto: true
				});
			} else if (selecionado == '/hospital' || selecionado == '/hospitalConvenio' || selecionado == '/radiologista' || selecionado == '/exame'
				|| selecionado == '/grupoFaturamento' || selecionado == '/contrato') {
				this.setState({
					...this.state,
					cadastroAberto: true
				});
			}
		}		
		
		return (
			<nav className="mt-2">

				{usuarioCarregado &&			    
				<ul className="nav nav-pills nav-sidebar flex-column nav-flat nav-compact" data-widget="treeview" role="menu" data-accordion="false">
					<MenuItem path='/' label='Dashboard' icon='fas fa-tachometer-alt' active={selecionado == '/'} />
					
					{usuarioCarregado.acesso_cadastro_usuario &&
					<MenuTree icon={'fas fa-user-lock'} label={'Acesso'}
						display={this.state.acessoAberto}
						onClick={() =>
							this.setState({
								...this.state,
								acessoAberto: !this.state.acessoAberto,
							})
						} >
						<MenuItem submenu path='usuario' label='Usuário' icon='fas fa-id-card-alt' active={selecionado == '/usuario'} />
					</MenuTree>}

					{usuarioCarregado.acesso_cadastros &&
					<MenuTree icon={'fas fa-cogs'} label={'Cadastro'}
						display={this.state.cadastroAberto}
						onClick={() =>
							this.setState({
								...this.state,
								cadastroAberto: !this.state.cadastroAberto,
							})
						} >
						<MenuItem submenu path='hospital' label='Hospital' icon='fas fa-hospital-alt' active={selecionado == '/hospital'} />
						<MenuItem submenu path='hospitalConvenio' label='Convênio' icon='fas fa-file-medical' active={selecionado == '/hospitalConvenio'} />
						<MenuItem submenu path='radiologista' label='Radiologista' icon='fas fa-user-md' active={selecionado == '/radiologista'} />
						<MenuItem submenu path='exame' label='Exame' icon='fas fa-file-medical-alt' active={selecionado == '/exame'} />
						<MenuItem submenu path='grupoFaturamento' label='Grupo de Faturamento' icon='fas fa-users' active={selecionado == '/grupoFaturamento'} />
						<MenuItem submenu path='contrato' label='Contrato' icon='fas fa-file-contract' active={selecionado == '/contrato'} />
					</MenuTree>}

					{usuarioCarregado.acesso_producoes &&
					<MenuItem path='laudoImportacao' label='Importação de Laudos' icon='fas fa-file-upload' active={selecionado == '/laudoImportacao'} />}
					{usuarioCarregado.acesso_producoes &&
					<MenuItem path='relatorioRadiologistaSintetico' label='Produções Sintético' icon='fas fa-file-alt' active={selecionado == '/relatorioRadiologistaSintetico'} />}
					{usuarioCarregado.acesso_producoes &&
					<MenuItem path='relatorioRadiologistaAnalitico' label='Produções Analítico' icon='fas fa-list' active={selecionado == '/relatorioRadiologistaAnalitico'} />}
					{usuarioCarregado.acesso_producoes &&
					<MenuItem path='relatorioHospital' label='Produções Hospital' icon='fas fa-file-invoice' active={selecionado == '/relatorioHospital'} />}
				</ul>}
			</nav>
		);
	}
}

const mapStateToProps = state => ({
	usuario: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado
});
const mapDispatchToProps = dispatch => bindActionCreators({ carregarUsuario }, dispatch);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Menu));
